import { useEffect, useState } from "react";
import {
  isFinalDateAvailable,
  knownFinalDateAvailability,
} from "@core/services/FinalDateService";

/**
 * Vrai seulement une fois la RPC `set_poll_final_date` confirmée en base.
 * `false` tant qu'on ne sait pas : on garde l'ancien parcours. La valeur est
 * mémorisée pour la session : seul le tout premier montage déclenche la sonde
 * (et donc un rendu de plus).
 */
export function useFinalDateAvailable(): boolean {
  const [available, setAvailable] = useState<boolean>(
    () => knownFinalDateAvailability() ?? false,
  );
  useEffect(() => {
    if (knownFinalDateAvailability() !== null) return;
    let cancelled = false;
    void isFinalDateAvailable().then((ok) => {
      if (!cancelled && ok) setAvailable(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return available;
}
